'use strict'

import {bootstrap} from '../bootstrap/bootstrap'

const tabbedCarousels = Array.from(document.querySelectorAll('.tabbed-carousel'))

export function updateNav(tab, tabbedCarousel) {
  tabbedCarousel.querySelector('.tabbed-carousel__nav .tab--current').classList.remove('tab--current')
  tabbedCarousel.querySelector(`.tabbed-carousel__nav a[data-tab='${tab}']`).classList.add('tab--current')
  tabbedCarousel.querySelector(`.dropdown__ui span`).innerHTML = document.querySelector(`.tabbed-carousel__nav--dropdown select option[value="${tab}"]`).innerText
}

export function attachMobileNavHandlers(select, tabbedCarousel) {
  select.addEventListener('blur', () => {
    updateContent(select.options[select.options.selectedIndex].value, tabbedCarousel)
  })
  select.addEventListener('change', () => {
    updateContent(select.options[select.options.selectedIndex].value, tabbedCarousel)
  })
}

export function attachNavHandlers(anchor, tabbedCarousel) {
  anchor.addEventListener('click', e => {
    e.preventDefault()
    if (!anchor.classList.contains('tab--current')) {
      updateContent(anchor.getAttribute('data-tab'), tabbedCarousel)
    }
  })
}

function hideContent(callback, tabbedCarousel) {
  const currentContent = tabbedCarousel.querySelector('.content-block--current')
  currentContent.classList.remove('content-block--current')
  window.setTimeout(() => {
    currentContent.style.display = 'none'
    callback()
  }, 800)
}

function updateContent(tabContent, tabbedCarousel) {
  const content = tabbedCarousel.querySelector(`.content-block[data-content="${tabContent}"]`)

  updateNav(tabContent, tabbedCarousel)
  hideContent(() => {
    content.style.display = 'flex'
    window.setTimeout(() => {
      content.classList.add('content-block--current')
    }, 100)
  }, tabbedCarousel)
}

bootstrap(tabbedCarousels, tabbedCarousel => {
  const tabbedCarouselMobileNavDropdown = document.querySelector('.tabbed-carousel__nav--dropdown select')
  const tabbedCarouselNavAnchors = Array.from(tabbedCarousel.querySelectorAll('a.tab'))
  bootstrap(tabbedCarouselNavAnchors, attachNavHandlers, tabbedCarousel)
  bootstrap(tabbedCarouselMobileNavDropdown, attachMobileNavHandlers, tabbedCarousel)
})
